import { useTranslation } from 'react-i18next';
import { Alert } from '@/shared/ui';
import { DETAIL_QUERY_STALE_TIME_MS } from '@/shared/lib/queryClient';
import { useAgendaParams } from '@/shared/navigation/react/useAgendaParams';
import { useGetProductsStationChain } from '@/api/generated/products-station-chains/products-station-chains';
import { stationChainDetailAgenda } from './stationChainDetailAgenda';
import { StationChainDetailView } from './StationChainDetailView';
import {
  emptyStationChainFormValues,
  fromGetStationChainResponse,
} from './stationChainFormSchema';

interface StationChainDetailPageProps {
  layerId: string;
}

/** Thin loader: vyřeší parametr agendy a (v editaci) načtení detailu trasy; pak vykreslí view. */
export function StationChainDetailPage({ layerId }: StationChainDetailPageProps) {
  const { t } = useTranslation('products');
  const { open } = useAgendaParams(stationChainDetailAgenda, layerId);
  const stationChainId = open.stationChainId;
  const isEdit = stationChainId != null;

  // Krátký staleTime — detail se při každém otevření načte znovu; po uložení navíc invaliduje (view).
  const chainQuery = useGetProductsStationChain(stationChainId ?? '', {
    query: { enabled: isEdit, staleTime: DETAIL_QUERY_STALE_TIME_MS },
  });

  if (isEdit && chainQuery.isLoading) {
    return <p className="text-phx-text-muted text-phx-sm p-4">{t('stationChain.loading')}</p>;
  }
  if (isEdit && chainQuery.isError) {
    return (
      <div className="p-4">
        <Alert severity="error" title={t('stationChain.loadErrorTitle')}>
          {t('stationChain.loadErrorDescription')}
        </Alert>
      </div>
    );
  }

  return (
    <StationChainDetailView
      layerId={layerId}
      stationChainId={stationChainId}
      initialValues={
        chainQuery.data
          ? fromGetStationChainResponse(chainQuery.data)
          : emptyStationChainFormValues()
      }
    />
  );
}
